import { zCurrency } from "@redotech/money/usd-amounts";
import { SubscriptionProduct } from "@redotech/redo-billing-common/unified-billing/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export type BillingProductSummary = z.infer<typeof billingProductSummary>;
export const billingProductSummary = z.object({
  product: createEnum(SubscriptionProduct),
  billingDueDate: z.date(),
  totalInvoiceAmount: z.number(),
  /** Bill currency. Foreign charges are struck into it before totalling. */
  currency: zCurrency,
});

/**
 * One entry per product the team is actually billed for; absent means no tile.
 */
export const getBillingProductSummaries = {
  name: "getBillingProductSummaries" as const,
  input: z.null(),
  output: z.array(billingProductSummary),
};
